import React from 'react'
import { Grid, LinearProgress, Typography } from '@material-ui/core';
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/styles';
// import Tr from 'translations/Translations';

const style = theme => ({
	root: {
		'&>*': {
			flexShrink: 0,
		}
	},
	labelItem: {
		marginRight: theme.spacing(2)
	},
	progressItem: {
		flexGrow: 1
	},
	progressGrid: {
		height: '100%',
		justifyContent: 'center',
	}
})

function ProgressBar({
	classes,
	value,
	max
}) {
	const progress = parseInt((value/max) * 100)
	return (
		<Grid container className={classes.root}>
			<Grid item className={classes.labelItem}>
				<Typography variant='caption'>
					{/* {Tr('completed')} {progress}% ({value}/{max} {Tr('fields')}) */}
					{progress}%
				</Typography>
			</Grid>
			<Grid item className={classes.progressItem}>
				<Grid container direction='column' className={classes.progressGrid}>
					<Grid item>
						<LinearProgress  variant='determinate' value={progress} />
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

ProgressBar.propTypes = {
	value: PropTypes.number.isRequired,
	max: PropTypes.number.isRequired,
}

ProgressBar.defaultProps = {
}

export default withStyles(style)(ProgressBar);
